import ReactSelect from 'react-select'

import * as styles from './ReactSelect.style'


export interface Option {
  label: string
  value: string
}

interface Props {
  options: Option[]
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onChange: (value: any) => void
  isMulti?: boolean
  placeholder?: string
}

const MultiSelect = ({ options, onChange, isMulti = true, placeholder }: Props): JSX.Element => (
  <ReactSelect
    isMulti={isMulti}
    options={options}
    onChange={onChange}
    placeholder={placeholder}
    styles={styles.reactSelectStyles}
  />
)

export default MultiSelect
